// extracted by mini-css-extract-plugin
export default {"contents":"portfolio_contents__rntNb","title":"portfolio_title__1d0nb"};